<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner3.png">
        <div class="box-font">办事指南</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
          <leftmenu :value='type' :list='guide_typelist' @datashow=listshow></leftmenu>
          <!--登录-->
          <leftlogin :formData.sync="form"></leftlogin>
        </div>
        <div style="margin-left: 20px;padding:20px;width:100%; border: 1px solid #CCCCCC;">
          <h3 style="text-align: center;">{{ detail.Title }}</h3>
          <p style="text-align: center;font-size: 16px;">{{ detail.CreateTime.slice(0, 10) }}</p>
          <!-- <a style="float: right;padding-right: 30px;color:red;" :href="detail.Annex" v-show="detail.Annex">下载附件</a> -->
          <div style="padding-top: 30px;" v-html=detail.Content></div>
        </div>

      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
import leftlogin from "../components/leftlogin.vue";
import leftmenu from "../components/leftmenu.vue";
export default {
  name: "home",
  components: { leftlogin, leftmenu },
  data() {
    return {
      guide_typelist: [],
      detail: {},
      Id: 0,
      type: 0,
      form: {
        name: "",
        pass: "",
        type: ""
      }
    };
  },
  created() {
    var that = this;
    that.type = this.$route.query.type;
    that.Id = that.$route.query.id;
    var menulist = JSON.parse(window.localStorage.getItem("menulist")) || [];
    that.guide_typelist = menulist.filter(function (item) {
      return item.Word_Group_Key == 'GuideType'
    });
    this.getData();
  },
  methods: {
    getData() {
      var that = this;
      that.$api.get("/Policy/" + that.Id, null, r => {
        that.detail = r.response;
      });
    },
    listshow(item) {
      this.$router.replace("/Guide?id=" + item.Word_Value);
      return false;
    }
  },
  watch: {
    $route(to) {
    }
  },
  computed: {

  }
};
</script>

<style>
article.newhome {
  width: 1300px;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}

.pagination {
  text-align: center;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}
</style>
